export type EntityWithNames = {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
};

export const printEntityName = (entity: EntityWithNames) => {
  return entity.displayName || `${entity.firstName || ''} ${entity.lastName || ''}`.trim();
};

export const printEntityListNames = (entities: EntityWithNames[]) => {
  return entities
    .map((entity) => printEntityName(entity))
    .filter(Boolean)
    .join(', ');
};

export const withDsLink = (url: string) => url;
